var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9", attrs: { id: "main" } }, [
              _c("div", { staticClass: "container shortcode travel-ideas" }, [
                _c("h1", { staticClass: "idea-title" }, [
                  _vm._m(0),
                  _vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale])),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "booking-information sdr-box" }, [
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_h4_1[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_p_1[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_p_2[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_p_3[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("br"),
                _c("h5", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_h5_1[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_p_4[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.seat_li_1[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.seat_li_2[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.seat_li_3[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.seat_li_4[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.seat_li_5[_vm.getCurrentLocale]),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_p_5[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_p_6[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("br"),
                _c("h5", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_h5_2[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_p_7[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.seat_li_1[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.seat_li_2[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.seat_li_3[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.seat_li_4[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.seat_li_5[_vm.getCurrentLocale]),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_p_8[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_p_9[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.seat_p_10[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.phone[_vm.getCurrentLocale]) +
                      ":  +49 (0)30 53 67 67 91"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.email[_vm.getCurrentLocale]) +
                      ": "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "mailto:kundenservice@sundair.com" } },
                    [_vm._v("Kundenservice@Sundair.com")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar col-md-3" },
              [_c("sdr-aboutsundair-box"), _vm._v(" "), _c("sdr-contact-box")],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sdr-promobox"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }